import React, { Component } from 'react';
import AdminBrandModelTable from './AdminBrandModelTable';

export class AdminBrandModelContent extends Component {
  render() {

    return (
      <AdminBrandModelTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminBrandModelContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminBrandModel/AdminBrandModelContent.js